const WINDOW_POST_MESSAGE_PAYMENT_DONE = 'PAYMENT_DONE';

interface UsePaymentCompleteNotification {
  subscribeNotificationHandler(parentMessageListener: () => void): void;
  notifyCompletePayment(): void;
}

export const usePaymentCompleteNotification =
  (): UsePaymentCompleteNotification => {
    const subscribeNotificationHandler = (
      parentMessageListener: () => void,
    ) => {
      const listener = (event: MessageEvent) => {
        if (event.data === WINDOW_POST_MESSAGE_PAYMENT_DONE) {
          parentMessageListener();
        }
      };

      window.addEventListener('message', listener);

      return () => window.removeEventListener('message', listener);
    };

    const notifyCompletePayment = () => {
      if (window.opener) {
        window.opener.postMessage(
          WINDOW_POST_MESSAGE_PAYMENT_DONE,
          window.location.origin,
        );
      }

      if (window.parent) {
        window.parent.postMessage(
          WINDOW_POST_MESSAGE_PAYMENT_DONE,
          window.location.origin,
        );
      }
    };

    return {
      subscribeNotificationHandler,
      notifyCompletePayment,
    };
  };
